import { Referrals } from '@/features/referrals/components/Referrals'
import { Page } from '@/ui-kit'

export const ReferralsPage = () => (
  <Page>
    <Referrals />
  </Page>
)

export default ReferralsPage
